import React from 'react';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { string as stringType } from 'prop-types';
import styles from './FallbackCard.module.scss';

const FallbackCard = ({
  imageUrl, header, subheader, footerUrl, footer
}) => {
  return (
    <Col className="dynamic-recs uds-recently-viewed" data-type="container">
      <div className={styles['fallback-container']}>
        <div className={styles['fallback-image-container']}>
          <Image
            className={styles['card-image']}
            src={imageUrl}
            alt="main-product-image"
            height="300"
            width="300"
          />
        </div>
        <p className={styles['fallback-card-header']}>{header}</p>
        <p className={styles['fallback-card-subheader']}>{subheader}</p>
        <a href={footerUrl} className="u__default-link">{footer}</a>
      </div>
    </Col>
  );
};

FallbackCard.propTypes = {
  imageUrl: stringType,
  header: stringType,
  subheader: stringType,
  footerUrl: stringType,
  footer: stringType
};

FallbackCard.defaultProps = {
  imageUrl: null,
  header: null,
  subheader: null,
  footerUrl: null,
  footer: null
};

export { FallbackCard };